<div class="modal no-overflow  " [ngClass]="visible ? 'show' : ''">
  <div class="modal__layer" (click)="handleClose.emit()"></div>
  <div class="modal__box  show" id="modal02">
    <div class="modal__box__head">
      Tipo de sanciones
      <a class="modal__close global-hand" (click)="handleClose.emit()"></a>
    </div>
    <div class="modal__box__body">
      <div class="modal__table">
        <div class="tr" *ngFor="let row of matrix | slice: 0 : 1; let index = index ">
          <ng-container *ngFor="let field of row">
            <div class="th" [ngClass]="index % 2 ? 'background-grey' : ''">{{field}}</div>
          </ng-container>
        </div>
        <div class="tr" *ngFor="let row of matrix | slice: 1; let index = index ">
          <ng-container *ngFor="let field of row">
            <div class="td">{{field}}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
